import React, { useState, useContext, useEffect, useMemo } from 'react'
import { JsonForms } from '@jsonforms/react'
import { materialRenderers, materialCells } from '@jsonforms/material-renderers'
import { DesignContext } from 'contexts/DesignContext'
import { Modal } from 'react-bootstrap'
import objectPath from 'object-path'
import ComponentWrapper from 'designer/component/system/layout/control/ComponentWrapper'
import styles from 'designer/styles/modal.module.css'
import { modalDefault } from 'designer/component/system/themes/containerTheme'

import { createSystemRenderer } from 'designer/component/control/renderer'
import { debounceCallback } from 'utility/debounceCallback.util'

const ModalBox = (props) => {
  let { data, path, handleChange, uischema } = props

  const designContext = useContext(DesignContext)
  const {
    jsonForm,
    setUischema,
    findUischemaIndex,
    findUiSchema,
    findSchema,
    openModal,
    setOpenModal,
  } = designContext

  const [modal, setModal] = useState({})
  const [body, setBody] = useState({})
  const [footer, setFooter] = useState({})

  const [isLoadBody, setIsLoadBody] = useState(false)
  const [isLoadFooter, setIsLoadFooter] = useState(false)

  const bodyRenderer = useMemo(() => {
    if (modal?.uischema?.isOpen && body?.uischema) {
      let bodyRenderer = createSystemRenderer(body.uischema.elements)
      return bodyRenderer
    }
    return []
  }, [body?.uischema?.key])

  const footerRenderer = useMemo(() => {
    if (modal?.uischema?.isOpen && footer?.uischema) {
      let footerRenderer = createSystemRenderer(footer.uischema.elements)
      return footerRenderer
    }
    return []
  }, [footer?.uischema?.key])

  useEffect(() => {
    if (uischema.key === openModal) {
      setIsLoadBody(true)
      setIsLoadFooter(true)
      let elements = jsonForm.uischema.elements
      let ui = getElement(elements, openModal)
      let schema = getSchema()
      let modal = getModal(ui, schema)
      console.log('modal', modal)
      setModal(modal)
      let body = getPartModal(ui, schema, 'modalBody')
      setBody(body)
      let footer = getPartModal(ui, schema, 'modalFooter')
      setFooter(footer)
      debounceCallback(setIsLoadBody, [false], 'load-body', 0)
      debounceCallback(setIsLoadFooter, [false], 'load-footer', 0)
    }
  }, [uischema.key === openModal])

  const getSchema = () => {
    return objectPath.get(jsonForm, 'schema')
  }

  const getElement = (elements, key) => {
    let mapKey = jsonForm.schema.mapKey[key]
    let indices = findUischemaIndex(key, mapKey, jsonForm.uischema.elements)
    let newElements = findUiSchema(elements, indices)
    return newElements
  }

  const getModal = (uischema, schema) => {
    let mapName = objectPath.get(schema, `mapName.${uischema.key}`) || ''
    let indices = mapName.split('.') || []
    return {
      uischema: uischema,
      schema: findSchema(schema.properties, indices),
    }
  }

  const getPartModal = (uischema, schema, part) => {
    let found = uischema.elements.find(({ tagname }) => tagname === part)
    if (!found)
      return {
        uischema: {},
        schema: {},
      }
    let mapName = objectPath.get(schema, `mapName.${found.key}`) || ''
    let indices = mapName.split('.') || []
    return {
      uischema: found,
      schema: findSchema(schema.properties, indices),
    }
  }

  const style = {
    header: {
      background: objectPath.get(modal, `uischema.cardColor`) || '',
      padding: '1rem',
    },
    title: {
      color: objectPath.get(modal, `uischema.textColor`) || '',
      fontSize: '1rem',
    },
  }

  const closeModal = () => {
    let elements = jsonForm.uischema.elements
    let newElements = getElement(elements, modal.uischema.key)
    newElements.isOpen = false
    let newUiSchema = jsonForm.uischema
    newUiSchema.elements = elements
    setUischema(newUiSchema)
    setOpenModal(null)
  }

  return (
    <>
      {objectPath.get(modal, 'uischema.key') && (
        <>
          {modal.uischema.modalSize === 'fullscreen' ? (
            <Modal
              fullscreen="true"
              dialogClassName={styles.modalFullScreen}
              className="pl-0"
              show={modal.uischema.isOpen}
            >
              <Modal.Header
                closeButton
                onHide={closeModal}
                style={style.header}
              >
                <Modal.Title style={style.title}>
                  {modal.uischema.title}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="p-0 pt-4">
                <ComponentWrapper
                  {...props}
                  theme={modalDefault}
                  isLoad={isLoadBody}
                >
                  <JsonForms
                    schema={body.schema}
                    uischema={body.uischema}
                    data={data}
                    renderers={bodyRenderer}
                    cells={materialCells}
                    onChange={({ data, errors }) => {
                      handleChange(path, data)
                    }}
                  />
                </ComponentWrapper>
              </Modal.Body>
              <Modal.Footer className="w-100">
                <ComponentWrapper
                  {...props}
                  theme={modalDefault}
                  isLoad={isLoadFooter}
                  height={30}
                >
                  <JsonForms
                    schema={footer.schema}
                    uischema={footer.uischema}
                    data={data}
                    renderers={footerRenderer}
                    cells={materialCells}
                    onChange={({ data, errors }) => {
                      handleChange(path, data)
                    }}
                  />
                </ComponentWrapper>
              </Modal.Footer>
            </Modal>
          ) : (
            <Modal show={modal.uischema.isOpen} size={modal.uischema.modalSize}>
              <Modal.Header
                closeButton
                onHide={closeModal}
                style={style.header}
              >
                <Modal.Title style={style.title}>
                  {modal.uischema.title}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="p-0 pt-4">
                <ComponentWrapper
                  {...props}
                  theme={modalDefault}
                  isLoad={isLoadBody}
                >
                  <JsonForms
                    schema={body.schema}
                    uischema={body.uischema}
                    data={data}
                    renderers={bodyRenderer}
                    cells={materialCells}
                    onChange={({ data, errors }) => {
                      handleChange(path, data)
                    }}
                  />
                </ComponentWrapper>
              </Modal.Body>
              <Modal.Footer className="w-100">
                <ComponentWrapper
                  {...props}
                  theme={modalDefault}
                  isLoad={isLoadFooter}
                  height={30}
                >
                  <JsonForms
                    schema={footer.schema}
                    uischema={footer.uischema}
                    data={data}
                    renderers={footerRenderer}
                    cells={materialCells}
                    onChange={({ data, errors }) => {
                      handleChange(path, data)
                    }}
                  />
                </ComponentWrapper>
              </Modal.Footer>
            </Modal>
          )}
        </>
      )}
    </>
  )
}

export default ModalBox
